<div class="overlay" [class.visible]="isSidebarOpen" (click)="closeSidebar()"></div>
<div *ngIf="isSidebarOpen && requestPage !='1'" class="sidebar">
    <div class="header">
      <mat-icon (click)="closeSidebar()"  class="headerclosebutton">keyboard_backspace</mat-icon>
      <h2>Enter Item List</h2>
      <p class="help" (click)="needHelp()">NEED HELP?</p>
      <!-- <mat-icon  (click)="closeSidebar()" class="headerclosebutton">close</mat-icon> -->
    </div>
   
      <!-- <mat-form-field appearance="outline" floatLabel="never" style="width: 91%;margin-top: -9px;margin-left: 18px;">
        <mat-select [(value)]="selectedKits" (selectionChange)="onKitsChanged()" multiple [placeholder]="'Select from kits'">
          <mat-select-trigger style="top: -3px;position: relative;">
            Select from kits
        </mat-select-trigger>
        <mat-option *ngFor="let kit of kits" [value]="kit" >{{ kit.name }}</mat-option>
      </mat-select>
    </mat-form-field> -->
      <mat-form-field appearance="outline" floatLabel="never" style="width: 91%;  margin-left: 18px;">
        <mat-select #kitSelect
                    [(value)]="selectedKits"
                    (selectionChange)="onKitsChanged()"
                    multiple
                    [placeholder]="'Select from kits'">
      
          <mat-select-trigger style="top: -3px; position: relative;">
            Select from kits
          </mat-select-trigger>
      
          <mat-option *ngFor="let kit of kits" [value]="kit">
            {{ kit.name }}
          </mat-option>
      
            <div class="ok-button-container">
              <p (click)="closeSelectPanel(kitSelect)" style="margin-top: 0;">OK</p>
            </div>
      
        </mat-select>
      </mat-form-field>
      
    <!-- Selected Chips -->
    <div class="chip-container" >
      <mat-chip-listbox>
        <mat-chip-option *ngFor="let kit of selectedKits" [removable]="true" (removed)="removeKit(kit)" class="chip">
          {{ kit.name }}
          <mat-icon matChipRemove class="remove" (click)="removeKit(kit)">cancel</mat-icon>
        </mat-chip-option>
      </mat-chip-listbox>
    </div>

    <!-- <textarea [(ngModel)]="itemList" rows="20" placeholder="Enter items here..."></textarea> -->
     <div class="matformfieldnew">
      <label style="font-weight: bold; margin-bottom: 4px; display: block;">Enter Item Names</label>
        <mat-form-field appearance="outline" style="width: 100%;margin-bottom: 62px;">
        <!-- <mat-form-field  class="custom-mat-form-field"> -->
          <!-- <div class="custom-textarea-container"> -->
            <mat-label>Enter items here</mat-label>
            <textarea matInput [(ngModel)]="itemList" (ngModelChange)="onItemListChanged()" rows="15" style="text-align: left;"></textarea>
          <!-- </div> -->
        </mat-form-field>   
    </div> 
    <div class="enterbutton">
      <p *ngIf="showError" class="Error" style="color: red;">Please enter at least one item name to proceed.</p>
      <button class="cta-btn" (click)="submitItems()">Enter</button>
       <button class="cta-btn1" (click)="wishlistItems()">
        <mat-icon class="favorite">favorite</mat-icon>Add to Request Wishlist</button>

    </div>
</div>
<div class="overlay" [class.visible]="popup" (click)="closePopup()"></div>
<div *ngIf="popup" class="popup">
  <div style="text-align: right;">
  <i (click)="closePopup()" style="cursor: pointer;"> cancel</i>
  </div>
  <div style="text-align: center;">
    <img src="../../../../assets/images/item_list.png" style="width: 74%;">
  </div>
  <div style="text-align: center;margin-top: 12px;">
    <button class="okay" (click)="closePopup()">Okay, Got it</button>
  </div>
</div>
<div #wishlistcontainer></div>